export type EmployeeBucketId = 'lt_20' | 'e20_100' | 'e100_500' | 'e500_1500' | 'e1500_plus';

export const EMPLOYEE_FILTER_BUCKETS: {
  id: EmployeeBucketId;
  label: string;
}[] = [
  { id: 'lt_20', label: 'до 20' },
  { id: 'e20_100', label: '20 – 100' },
  { id: 'e100_500', label: '100 – 500' },
  { id: 'e500_1500', label: '500 – 1500' },
  { id: 'e1500_plus', label: '1500+' },
];

export const ALL_EMPLOYEE_BUCKET_IDS: EmployeeBucketId[] = EMPLOYEE_FILTER_BUCKETS.map((b) => b.id);

function employeeInBucket(employeeAmount: number, id: EmployeeBucketId): boolean {
  switch (id) {
    case 'lt_20':
      return employeeAmount <= 20;
    case 'e20_100':
      return employeeAmount > 20 && employeeAmount <= 100;
    case 'e100_500':
      return employeeAmount > 100 && employeeAmount <= 500;
    case 'e500_1500':
      return employeeAmount > 500 && employeeAmount <= 1500;
    case 'e1500_plus':
      return employeeAmount > 1500;
    default:
      return false;
  }
}

export function employeeMatchesSelectedBuckets(
  employeeAmount: number | null,
  selected: EmployeeBucketId[],
): boolean {
  if (selected.length === 0) return false;
  if (employeeAmount === null) return true;
  return selected.some((id) => employeeInBucket(employeeAmount, id));
}
